<div class="detail-section-wrapper">
  <mat-drawer-container #matDrawerContainer (backdropClick)="closeBackdrop()">
    <mat-drawer role="navigation" class="left-sidenav-drawer" #leftnav [opened]="leftSideNav">
      <uni-left-sidenav-collapsed
        (toggle)="closeBackdrop()"
        [showSidenav]="true"
        [showDiscoverSection]="true">
      </uni-left-sidenav-collapsed>
    </mat-drawer>

    <mat-drawer-content>
      <div class="fixed top-0" fxLayout="row" *ngIf="!mobileView">
        <uni-left-sidenav-collapsed
          (toggle)="leftnav.toggle()"
          [showSidenav]="false"
          [showDiscoverSection]="false">
        </uni-left-sidenav-collapsed>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>

<div class="main-section-wrapper">
  <ng-container *ngIf="isLoading; else viewTemplate">
    <div
      class="height-50vh section-bg section-padding"
      fxLayout="row"
      fxLayoutAlign="center center">
      <uni-loader></uni-loader>
    </div>
  </ng-container>

  <ng-template #viewTemplate>
    <ng-container *ngIf="blog">
      <div
        fxLayout="row"
        fxLayoutGap="16px"
        [class.padding-right-10]="showFloatingShare.horizontally">
        <div class="width-100" fxLayout="column" fxLayoutGap="16px">
          <div class="section-bg overflow-hidden">
            <div *ngIf="blog.image">
              <img class="cover-image fit-cover" [src]="blog.image" alt="blog.title" />
            </div>
            <!-- <div class="title-wrapper" *ngIf="titleAppearance">
              <h1 class="title margin-0 padding-1">{{blog.title}}</h1>                          
            </div> -->
            <uni-json-ld-schema [itemLD]="articleSchema"></uni-json-ld-schema>
            <div
              fxLayout="column"
              class="width-100 margin-auto section-bg section-padding"
              fxLayoutGap="32px">
              <ng-container *ngIf="blog.content || blog.body; else membershipView">
                <uni-blog-panel
                  [blog]="blog"
                  [self]="self"
                  [user]="user"
                  [blogCopyLink]="blogCopyLink"
                  [source]="source"
                  (metaSectionTop)="setMetaPosition($event)">
                </uni-blog-panel>
              </ng-container>
              <ng-template #membershipView>
                <div class="blog-panel-container">
                  <div class="relative title-section">
                    <h1 class="text-center font-lg font-bold reader-title">{{ blog.title }}</h1>
                    <p class="font-sm text-center sparro-grey-800 reader-subtitle">
                      {{ blog.tagline }}
                    </p>
                    <div class="absolute fd-box"></div>
                  </div>
                  <div class="lt-ex-section">
                    <ng-container *ngIf="user; else unauthView">
                      <p class="tle margin-0">
                        Uh-oh! Monthly journal-viewing limit reached: 3 journals.
                      </p>
                      <p class="sbtle margin-0">
                        Ready to break free into unlimited inspiration? <br /><br />
                        Level up with our Uni Membership and unlock unlimited content starting at just <b>9 USD</b>
                      </p>

                      <a [href]="membershipPageUrl" class="mem-btn cursor-pointer no-decor">
                        Get Membership
                      </a>
                    </ng-container>
                    <ng-template #unauthView>
                      <p class="tle margin-0">Ready to dive into the full journal extravaganza?</p>
                      <p class="sbtle margin-0">
                        Put on your login shoes, step into the full journal experience, and unlock a
                        world of architectural wonders. <br /><br />
                        Let's groove together and embark on an amazing journey of inspiration!
                      </p>

                      <a [href]="authPageUrl" class="ath-btn cursor-pointer no-decor">
                        Login/Signup
                      </a>
                    </ng-template>
                  </div>
                </div>
              </ng-template>

              <mat-divider
                style="border-top-width: 2.5px"
                class="margin-top-2 flex-container"></mat-divider>

              <section
                fxLayout="row"
                fxLayoutAlign="space-between center"
                *ngIf="blog.author"
                class="flex-container">
                <div fxLayout="row" fxLayoutGap="24px" fxLayoutAlign="center center">
                  <uni-user-avatar [user]="blog.author" avatarClass="blog-author-avatar">
                  </uni-user-avatar>
                  <div fxLayout="column" fxLayoutGap="8px" style="flex-grow: 1">
                    <a [href]="getProfileUrl(blog)" class="cursor-pointer title-text no-decor"
                      >{{ blog.author.first_name | titlecase }}
                      {{ blog.author.last_name | titlecase }}</a
                    >
                    <span *ngIf="blog.author.bio" class="subtitle-text">{{ blog.author.bio }}</span>
                  </div>
                </div>

                <!-- active="Following"
                activeHover="Unfollow"
                [activeState]="blog?.author?.is_following ? true : false"
                inactiveHover="Follow" -->
                <uni-state-button
                  [default]="blog?.author?.is_following ? 'Following' : 'Follow'"
                  (click)="toggleUserFollow()"
                  button_class="secondary"
                  *ngIf="!self">
                </uni-state-button>
              </section>

              <mat-divider style="border-top-width: 2.5px" class="flex-container"></mat-divider>

              <div class="blog-footer flex-container" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="space-between center">
                  <uni-like-button
                    [item]="blog"
                    [source]="source"
                    [border]="true"
                    [showCount]="true">
                  </uni-like-button>

                  <div *ngIf="blog?.views">
                    {{ blog.views }} {{ blog.views > 1 ? 'views' : 'view' }}
                  </div>
                </div>
                <uni-share-button-group
                  [item]="blog"
                  [showFloatingShare]="
                    showFloatingShare.vertically && showFloatingShare.horizontally
                  "
                  [commentSectionTop]="commentSectionTop"
                  [content]="sharedContent"
                  [source]="source"
                  [slug]="blog.slug"
                  [report]="blog?.report"
                  [following]="blog?.is_following"
                  [user]="user"
                  [sourceCopy]="blogCopyLink"
                  [self]="self">
                </uni-share-button-group>
              </div>
            </div>
          </div>
          <div class="section-bg section-padding">
            <section class="width-100 flex-container" #commentSection>
              <p class="sparro-orange-600 font-sm margin-bottom-2">
                Comments ({{ blog.comments }})
              </p>
              <mat-divider style="margin-bottom: 16px"></mat-divider>
              <uni-comment-group
                [slug]="blog.slug"
                [source]="source"
                [user]="user"
                (counter)="counter($event)">
              </uni-comment-group>
            </section>
          </div>
        </div>

        <div
          fxLayout="column"
          class="blog-sidenav"
          fxLayoutGap="16px"
          *ngIf="showFloatingShare.horizontally"
          #sidenav>
          <ng-container *ngIf="blog?.badges?.length">
            <a
              [href]="competitionUrl + blog.badges[0].compSlug + '/entries'"
              class="no-decor badge width-100 text-center font-xs">
              {{ blog.badges[0].title }}
            </a>
          </ng-container>
          <ng-container *ngIf="blog?.projects?.length">
            <div fxLayout="column" fxLayoutGap="16px" class="card-section">
              <p class="font-bold margin-0">Associated project</p>
              <uni-project-card [project]="blog.projects[0]"> </uni-project-card>
            </div>
          </ng-container>

          <ng-container *ngIf="featuredCompetition">
            <div fxLayout="column" fxLayoutGap="16px" class="card-section">
              <p class="font-bold margin-0">Featured competition</p>
              <uni-competition-card [competition]="featuredCompetition"></uni-competition-card>
            </div>
          </ng-container>

          <ng-container *ngIf="trendingArticles.length">
            <div fxLayout="column" fxLayoutGap="16px" class="card-section">
              <p class="font-bold margin-0">Trending articles</p>
              <uni-blog-cards-group [blogs]="trendingArticles"></uni-blog-cards-group>
            </div>
          </ng-container>

          <a
            href="https://news.google.com/publications/CAAqBwgKMPubqAsw6KbAAw?hl=en-IN&gl=IN&ceid=IN:en"
            target="_blank"
            class="no-decor padding-right-2 follow-button overflow-hidden"
            fxLayout="row"
            fxLayoutAlign="center center"
            fxLayoutGap="8px">
            <img
              src="https://uni-common-assets.s3.us-east-1.amazonaws.com/logo/google-news.svg"
              alt="google-news-logo"
              width="72px"
              height="72px" />
            <p class="margin-0 font-bolder width-100">Follow us on Google News</p>
            <i class="icon-open-in-new-tab-bold"></i>
          </a>

          <ng-container *ngIf="advertisement">
            <uni-advertisement-card [advertisement]="advertisement"> </uni-advertisement-card>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!showFloatingShare.horizontally">
      <ng-container *ngIf="blog?.projects?.length || featuredCompetition">
        <div class="width-100 bottom-section margin-bottom-4">
          <ng-container *ngIf="blog.projects.length">
            <div fxLayout="column" fxLayoutGap="16px" class="card-section">
              <p class="font-bold margin-0 text-center">Associated project</p>
              <uni-project-card [project]="blog.projects[0]" class="margin-x-auto">
              </uni-project-card>
            </div>
          </ng-container>
          <ng-container *ngIf="featuredCompetition">
            <div fxLayout="column" fxLayoutGap="16px" class="card-section">
              <p class="font-bold margin-0 text-center">Featured competition</p>
              <uni-competition-card
                [competition]="featuredCompetition"
                class="margin-x-auto"></uni-competition-card>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <a
        href="https://news.google.com/publications/CAAqBwgKMPubqAsw6KbAAw?hl=en-IN&gl=IN&ceid=IN:en"
        target="_blank"
        class="no-decor padding-right-2 follow-button overflow-hidden margin-x-auto bottom-margin"
        fxLayout="row"
        fxLayoutAlign="center center"
        fxLayoutGap="8px">
        <img
          src="https://uni-common-assets.s3.us-east-1.amazonaws.com/logo/google-news.svg"
          alt="google-news-logo"
          width="72px"
          height="72px" />
        <p class="margin-0 font-bolder width-100">Follow us on Google News</p>
        <i class="icon-open-in-new-tab-bold"></i>
      </a>

      <div class="bottom-margin" *ngIf="advertisement">
        <uni-advertisement-card [advertisement]="advertisement"></uni-advertisement-card>
      </div>
    </ng-container>

    <ng-container *ngIf="similarBlogs?.length">
      <div class="similar-blog-section section-bg section-padding">
        <h2 class="font-lg font-bold sparro-grey-900 margin-x-auto text-center margin-bottom-0">
          Similar reads
        </h2>
        <h3 class="font-xs sparro-grey-800 font-regular similar-blog-section-subtitle text-center">
          Based on recent readings
        </h3>
        <uni-blog-cards-group [blogs]="similarBlogs.slice(0, blogsCount)"> </uni-blog-cards-group>
        <div class="text-center margin-y-4">
          <ng-container *ngIf="blogsCount >= similarBlogs.length; else loadMoreButton">
            <a [href]="getJournalFeedUrl()" target="_blank" class="no-decor">
              <uni-navigation-button default="Explore more" button_class="secondary">
              </uni-navigation-button>
            </a>
          </ng-container>
          <ng-template #loadMoreButton>
            <uni-state-button
              default="Load more"
              button_class="secondary"
              (click)="loadMore(blogsCount >= similarBlogs.length ? false : true)">
            </uni-state-button>
          </ng-template>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="similarCompetitions?.length">
      <div class="similar-comp-section section-bg section-padding">
        <p class="font-lg font-bold sparro-grey-900 text-center margin-bottom-0">
          Explore competitions under {{ blog.disciplines[0].name | titlecase }}
        </p>
        <p
          class="font-xs sparro-grey-800 font-regular similar-competition-section-subtitle text-center">
          Recommendations based on your readings
        </p>
        <uni-competition-cards-group
          [competitions]="similarCompetitions.slice(0, minCompetitionCount)"
          align="center">
        </uni-competition-cards-group>
        <div class="text-center margin-y-4">
          <a [href]="getCompetitionFeedUrl()" target="_blank" class="no-decor">
            <uni-navigation-button
              default="Explore more"
              button_class="secondary"
              icon_class="icon-open-in-new-tab">
            </uni-navigation-button>
          </a>
        </div>
      </div>
    </ng-container>
  </ng-template>
  <uni-public-footer></uni-public-footer>
</div>
